import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-feature-four',
  templateUrl: './feature-four.component.html',
  styleUrls: ['./feature-four.component.css']
})
export class FeatureFourComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
